import React, { Component } from 'react';
import GiftCardList from './GiftCardList';
import GiftCardView from './GiftCardView';
import WithRouter from 'custom/withRouter';

class GiftCardPage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const p = this.props;
        const giftCardId = p.params.id;
        const isSave = giftCardId > 0;

        return (

            <div>
                {
                    isSave
                        ?
                        <GiftCardView
                            name="cashRegisterSave"
                            params={p.params}
                            isDialog={false}
                            title="Gift Card Info" />
                        :
                        <GiftCardList />

                }
            </div>
        );
    }
}

export default WithRouter(GiftCardPage);